// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
import "@babel/polyfill"
import promise from 'es6-promise'
promise.polyfill()
ElementUI.Dialog.props.closeOnClickModal.default = false
router.beforeEach(function (to, from, next) {
    if (to.meta.requireAuth) {
        var token = window.sessionStorage.getItem("token")
        if (token == undefined || token == null || token == '') {
            next({
                path: "/login"
            });
        }
    }
    next();
});
Vue.directive('role', {
    inserted (el, binding) {
        var userType = window.sessionStorage.getItem('userType')
        if (!binding.value.includes(userType)) {
            el.parentNode.removeChild(el)
        }
    }
})
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js